import styled from 'styled-components';
import { tokens } from '../../public/tokens';
import { buttonBase } from './buttonBase';
import { MOBILE_MEDIA_QUERY } from './breakpoints';

const { colors, globals } = tokens;

const buttonVariants = {
    primary: {
        background: colors.theme['button-color'],
        backgroundHover: colors.theme['button-hover-color'],
        backgroundActive: colors.theme['button-active-color'],
        color: colors.neutral.white,
        borderColor: 'transparent',
    },
    secondary: {
        background: colors.neutral.white,
        backgroundHover: colors.neutral.grey['100'],
        backgroundActive: colors.neutral.grey['200'],
        color: colors.text.primary,
        borderColor: colors.surfaces['border-divider'],
    },
    dark: {
        background: colors.brand['aie-blue']['500'],
        backgroundHover: colors.brand['aie-blue']['600'],
        backgroundActive: colors.brand['aie-blue']['700'],
        color: colors.neutral.white,
        borderColor: 'transparent',
    },
    success: {
        background: colors.states.success.default,
        backgroundHover: colors.states.success['600'],
        backgroundActive: colors.states.success['700'],
        color: colors.neutral.white,
        borderColor: 'transparent',
    },
    alert: {
        background: colors.states.alert.default,
        backgroundHover: colors.states.alert['600'],
        backgroundActive: colors.states.alert['700'],
        color: colors.neutral.white,
        borderColor: 'transparent',
    },
};

/**
 * The app's standard action button.
 * @param {'primary'|'secondary'|'dark'|'success'|'alert'} [$variant] Defaults to primary
 * @param {boolean} [$fullWidth] Stretches to fill its container
 */
export const Button = styled.button(({ $variant = 'primary', $fullWidth }) => {
    // An unrecognised variant would otherwise silently strip every colour off the button.
    const variant = buttonVariants[$variant] || buttonVariants.primary;

    return {
        ...buttonBase,
        justifyContent: 'center',
        width: $fullWidth ? '100%' : 'auto',
        padding: '8px 24px',
        borderColor: variant.borderColor,
        backgroundColor: variant.background,
        color: variant.color,

        ':hover': {
            backgroundColor: variant.backgroundHover,
        },
        ':active': {
            backgroundColor: variant.backgroundActive,
        },

        [MOBILE_MEDIA_QUERY]: {
            ...buttonBase[MOBILE_MEDIA_QUERY],
            padding: '8px 18px',
        },
    };
});

/**
 * Stacks full-width buttons vertically, e.g. two alternative actions either side
 * of a Divider. Any nested button stretches to the stack's width.
 */
export const ButtonStack = styled.div({
    display: 'flex',
    flexDirection: 'column',
    gap: globals['spacing-sm'],
    width: '100%',

    button: {
        width: '100%',
    },
});
